// 15px accounts for the horizontal scrollbar, otherwise it would eat into the rows
// area and re-trigger the inner vertical scroll the expanded mode removes
export const EXPANDED_GRID_SCROLLBAR_ALLOWANCE = 15;

interface IGetExpandedContentHeight {
  dataLength: number;
  headerHeight: number;
  isExpanded: boolean;
  rowHeight: number;
  rowsPerPage?: number;
}

export const getExpandedContentHeight = ({
  dataLength,
  headerHeight,
  isExpanded,
  rowHeight,
  rowsPerPage,
}: IGetExpandedContentHeight): number | undefined => {
  if (!isExpanded || !dataLength) {
    return undefined;
  }

  const visibleRows = rowsPerPage ? Math.min(dataLength, rowsPerPage) : dataLength;

  return headerHeight + visibleRows * rowHeight + EXPANDED_GRID_SCROLLBAR_ALLOWANCE;
};
